import { Component, Output, Input , EventEmitter, Injectable} from '@angular/core';

@Injectable({ providedIn: 'root' })
@Component({
  selector: 'upsell-product-box',
  templateUrl: 'upsell-product-box.html',
  styleUrls: ['upsell-product-box.scss'],
})
export class UpsellProductBoxComponent {
  @Input() productBoxTitle: string = '';
  @Input() productBoxSubtitle: string = '';
  @Input() image: string = 'assets/img/No-Image-Available.jpg';
  @Input() imageAlt: string = '';
  @Input() regularPrice: number = 0;
  @Input() instantSavings: number = 0;
  @Input() yourPrice: number = 0;
  @Input() currency: string = 'USD';  // TOUC-14710
  @Input() currencySymbol: string = '$';
  @Input() officialCurrency: string = 'USD';
  @Input() braintreeCurrencyConversion: number = 1;

  @Input() buttonYesText: string = `Yes I want this special added to my order`;
  @Input() buttonNoText: string = `No thanks, I understand that I won't see this offer again`;
  @Input() productBoxCTA: boolean = false;

  @Input() isAmazon: boolean = false;
  @Input() isPlaceOrder: boolean = true;
  @Input() showImage: boolean = true;

  @Input() regularText: string = 'Regular Price';
  @Input() instantSavingsText: string = 'Instant Savings';
  @Input() yourPriceText: string = 'Your Price';
  @Output() amazonPaymentEmitter: EventEmitter<void> = new EventEmitter();
  @Output() eventEmitter: EventEmitter<boolean> = new EventEmitter();

  constructor() {}

  nextPage(buttonValue: boolean) {
    this.eventEmitter.emit(buttonValue);
  }

  payWithAmazon() {
    this.amazonPaymentEmitter.emit();
  }
}
